<template>
    <div :data-type="type" class="form-item-date-input">
        <div class="custom-date-input">
            <input
                :id="fieldId"
                v-model="value"
                :type="type"
                :placeholder="placeholder"
                :class="[inputClass, { 'is-invalid': shouldShowError }]"
                class="form-control question-input-datepicker"
                :name="name" />
        </div>
        <div v-if="shouldShowError" class="has-error-msg invalid-feedback d-block">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script setup>
import { computed, watch } from 'vue';
import { useField } from 'vee-validate';
import { useTranslation } from '@/composables/useTranslation';

// INITIALIZE STORE & COMPOSABLES
const { translate } = useTranslation();

// PROPS & EMITS
const props = defineProps({
    errorText: {
        type: String,
        required: false,
    },
    fieldId: {
        type: Number,
        required: true,
    },
    helpText: {
        type: String,
        required: false,
    },
    inputClass: {
        type: String,
        required: false,
    },
    label: {
        type: String,
        required: true,
    },
    labelClass: {
        type: String,
        required: false,
    },
    modelAnswer: {
        type: String,
        required: false,
    },
    name: {
        type: String,
        required: true,
    },
    placeholder: {
        type: String,
        required: false,
    },
    question: {
        type: Object,
        required: true,
    },
    textSelect: {
        type: String,
        required: true,
    },
    type: {
        type: String,
        required: true,
    },
    validation: {
        type: Object,
        required: false,
    },
    hasSubmitted: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['update:modelAnswer']);

// REACTIVE VARIABLES

// COMPUTED PROPERTIES
const validationRules = computed(() => {
    return (value) => {
        if (props.validation.required && (!value || value.toString().trim() === '')) {
            return props.errorText || translate('label.this_value_is_required');
        }

        if (value && props.validation.dateFormat) {
            // Validar que sea una fecha válida
            const date = new Date(value);
            if (isNaN(date.getTime())) {
                return 'Invalid Date';
            }
        }

        return true;
    };
});

// Solo mostrar errores después del primer submit
const shouldShowError = computed(() => {
    return props.hasSubmitted && errorMessage.value;
});

// METHODS
// Configurar useField con validación lazy
const { value, errorMessage, meta } = useField(props.name, validationRules, {
    initialValue: props.modelAnswer,
    validateOnValueUpdate: false,
    validateOnMount: false,
});

// LIFECYCLE HOOKS
// Sincronizar con el valor externo
watch(() => props.modelAnswer, (newValue) => {
    value.value = newValue;
});

// Emitir cambios al componente padre
watch(value, (newValue) => {
    emit('update:modelAnswer', newValue);
});
</script>
